module.exports = __webpack_public_path__ + "static/img/4.fee39f7.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/5/6/1/zh/4.png
// module id = nXGg
// module chunks = 0